<template>
  <div>
    <span
      v-if="data.column.field === 'value'"
    >
      <b-form-input
        v-model.number="data.formattedRow.value"
        size="sm"
        step=".01"
        type="number"
        @blur="editMultipliersValue"
      />

    </span>
    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import store from '@/store'

export default {
  props: {
    data: {
      type: [Array, Object],
    },
  },
  setup(props) {
    const editMultipliersValue = () => {
      store.commit('SET_MULTIPLIERS_VALUE', props.data)
    }
    return { editMultipliersValue }
  },
}
</script>
